/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetRegionsAdminResponse } from '../models/GetRegionsAdminResponse';
import type { PostPutRegionRequestAdmin } from '../models/PostPutRegionRequestAdmin';
import type { RegionAdminDto } from '../models/RegionAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegionsService {
    /**
     * @returns RegionAdminDto OK
     * @throws ApiError
     */
    public static getRegionAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<RegionAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/regions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateRegionAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutRegionRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/regions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteRegionAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/regions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getRegionsAdmin({
        countryId,
        name,
        searchWord,
    }: {
        countryId?: number,
        name?: string,
        searchWord?: string,
    }): CancelablePromise<GetRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/regions',
            query: {
                'countryId': countryId,
                'name': name,
                'searchWord': searchWord,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns RegionAdminDto OK
     * @throws ApiError
     */
    public static postRegionAdmin({
        requestBody,
    }: {
        requestBody?: PostPutRegionRequestAdmin,
    }): CancelablePromise<RegionAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/regions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
